<template>
<div>
  <v-carousel
    :key="reloadCashierCarousel"
    height="95vh"
    hide-delimiter-background
    show-arrows
    @change="nextPreset"
  >
    <v-carousel-item
      v-for="(preset, i) in presetsToShowCase"
      :key="i"
    >
      <v-sheet
        :color="colors[Math.ceil(Math.random() * colors.length)]"
        height="100%"
      >
      </v-sheet>
    </v-carousel-item>
  </v-carousel>

  <v-row
    class="fill-height"
    justify-center
    align-center
  >
    <div class="display-3">
      <v-layout class="cashier-container">
        <v-row>
          <transition name="fade">
            <v-col v-show="cashierPreContainer" class="cashier-pre-container mt-2" cols="12">
              <Loader class="loader-style" />
              <Cashier
                setMaxHeight="85vh" />
            </v-col>
          </transition>
        </v-row>
      </v-layout>
    </div>
  </v-row>
</div>
</template>

<script>
import Cashier from '@/components/Cashier'
import Loader from '@/components/Loader'
import { initialConfig } from '@/utils/initialConfig'
import { initialTheme } from '@/utils/helpers'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  name: 'Carousel',
  components: {
    Cashier,
    Loader
  },
  props: {
    reloadCashierCarousel: { type: Number, required: true }
  },
  data: () => ({
    cashierPreContainer: true,
    colors: [
      'indigo',
      'warning',
      'pink darken-2',
      'red lighten-1',
      'theme-main-color',
      'orange',
      'purple',
      'green'
    ]
  }),
  methods: {
    ...mapMutations([
      'setPresetName'
    ]),
    ...mapActions([
      'overrwriteConfigs',
      'overwriteTheme'
    ]),
    nextPreset (index) {
      this.cashierPreContainer = false
      const presetName = this.presetsToShowCase[index].text
      const { config, theme } = this.presets[presetName]
      this.setPresetName(presetName)
      const newConfigs = {
        ...initialConfig(),
        ...config,
        ...this.cashierFillHeight && { containerHeight: '83vh' }
      }
      const newTheme = {
        ...initialTheme(),
        ...theme
      }
      this.overrwriteConfigs(newConfigs)
      this.overwriteTheme(newTheme)
      setTimeout(() => {
        this.cashierPreContainer = true
      }, 600)
    }
  },
  computed: {
    ...mapState({
      presetsToShowCase: ({ config }) => config.presetsToShowCase,
      presets: ({ config }) => config.allPresets
    })
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition-timing-function: ease-in;
  transition: opacity 1.3s;
}
.fade-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.loader-style {
  position: absolute;
  z-index: -1;
}
.cashier-container {
  position: absolute;
  top:0;
  left:0;
  .cashier-pre-container {
    position: relative;
    z-index: 50;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    height: 100vh;
    width: 100vw;
    #cashier-container,
    #cashier-preview {
      border-radius: 10px!important;
    }
  }
}
</style>
